import React from 'react';
import { ChatSession } from '../types/askStanley.types';

interface ChatDropdownProps {
    currentChatTitle: string;
    chats: ChatSession[];
    showDropdown: boolean;
    onToggleDropdown: () => void;
    onChatSelect: (chatId: string | number) => void;
    onCloseDropdown: () => void;
}

export const ChatDropdown: React.FC<ChatDropdownProps> = ({
    currentChatTitle,
    chats,
    showDropdown,
    onToggleDropdown,
    onChatSelect,
    onCloseDropdown,
}) => {
    const handleChatSelect = (chatId: string | number) => {
        onChatSelect(chatId);
        onCloseDropdown();
    };

    return (
        <div className='chat-dropdown-container relative min-w-0 flex-1'>
            <button
                onClick={onToggleDropdown}
                className='flex w-full cursor-pointer items-center justify-center gap-2 rounded-md px-3 py-2 text-center focus:outline-none'
                aria-expanded={showDropdown}
                aria-haspopup='listbox'
            >
                <span className='truncate font-semibold'>{currentChatTitle || 'Select a chat'}</span>
                <svg
                    className={`size-4 transition-transform ${showDropdown ? 'rotate-180' : ''}`}
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                >
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
                </svg>
            </button>

            {showDropdown && (
                <div className='bg-canvas absolute top-full left-0 z-50 mt-1 w-full space-y-1 rounded-md p-1 shadow-lg'>
                    {chats.map(chat => (
                        <button
                            key={chat.id}
                            onClick={() => handleChatSelect(chat.id)}
                            className='hover:bg-neutral-subtle w-full cursor-pointer rounded-md px-3 py-2 text-left transition-colors'
                        >
                            <div className='caption-1-bold text-dark truncate'>{chat.title}</div>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};
